<template>
	<div class="header">
		<div class="header__logo">
			<img :src="require('../assets/logo_pollotron.svg')" alt="Logo du Pollotron" />
		</div>
		<div class="header__powered">
			Propulsé par <a :href="info.contexte.urls.home" target="_parent">Contexte</a>
		</div>
		<div class="header__wrapper">
			<div class="header__intro">
				<p>À {{info.remainingDays}}&nbsp;jours du second tour de la présidentielle 2022, plongez dans les résultats des sondages et découvrez les tendances des finalistes.</p> 
			</div>
			<div class="header__byline">
				Conçu par <a :href="info.contexte.author.url" target="_parent">{{info.contexte.author.name}}</a> / Dernier sondage ajouté&nbsp;: {{info.lastPoll.organization}}, terminé le {{info.lastPoll.date}}
			</div>
			<div class="header__twitter">
				<a class="twitter" :href="info.twitter.url" target="_blank">
					<div class="twitter__text">Suivez {{info.twitter.name}} sur Twitter</div>
					<div class="twitter__image">
						<img :src="info.twitter.image" />
					</div>
				</a>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'Header',
		props: {
			info: {
				type: Object,
				required: true,
			},
			mobile: {
				type: Boolean,
				default: false,
			}
		}
	}
</script>
<style lang="scss">
	$fontTitle: 'alternate-gothic-atf', sans-serif;
	$greySpecial: #706F6F;
	@import 'global/css/contexte.apps'; 
	@import 'global/css/contexte.apps.colors'; 
	.header {
		margin-bottom: 6vw;
		&__logo {
			margin: 0 auto 1.2vw;
			width: clamp(280px, 35vw, 550px);
			img {
				width: 100%;
			}
		}
		&__powered {
			font-family: $fontTitle;
			font-size: clamp(22px, 2.2vw, 40px);
			font-weight: 400;
			text-transform: uppercase;
			text-align: center;
			color: $greySpecial;
			margin-bottom: 5vw;
			a {
				text-decoration: none;
				&:hover {
					text-decoration: underline;
				}
			}
		}
		&__wrapper {
			border-top: 5px solid $very-light-grey;
			border-bottom: 5px solid $very-light-grey;
			padding: 1.8em 0 2.2em;
			max-width: 600px;
			margin: 0 auto;
			text-align: center;
		}
		&__intro {
			margin-bottom: .8em;
			color: $dark-grey;
			p {
				margin:0;
			}
		} 
		&__byline {
			color: $another-grey;
			font-size: .85em;
			margin-bottom: .6em;
		}
		&__twitter {

		} 
	}
	.twitter {
		text-decoration: none;
		display: flex;
		justify-content: center;
		font-size: .85em;
		align-items: center;
		&:hover {
			text-decoration: underline;
		}	
		&__image {
			flex: 0 0 18px;
			img {
				@include blackwhite();
				width: 100%;
			}
		}
		&__text {
			padding-right: .5em;
			// color: $medium-grey;
		}
	}
	@media screen and (max-width: 600px)  {
		.header {
			margin-bottom: 3em;
			&__logo {
				margin-bottom: 1.2em;
			}
		}
	}

</style>
